  import React from 'react'

  const Footer = () => {
    return (
      <div>
      <footer id="footer">
      <div class="container">
        <h3>Eat Now</h3>
        <p>Eat now is best food delivery application, order food online from application and enjoy your delicious food.</p>
        <div class="social-links">
          <a href="#" class="twitter"><i class="bx bxl-twitter"></i></a>
          <a href="#" class="facebook"><i class="bx bxl-facebook"></i></a>
          <a href="#" class="instagram"><i class="bx bxl-instagram"></i></a>
          <a href="#" class="google-plus"><i class="bx bxl-skype"></i></a>
          <a href="#" class="linkedin"><i class="bx bxl-linkedin"></i></a>
        </div>
        <div class="copyright">
          &copy; Copyright <strong><span>Eat Now</span></strong>.All Rights Reserved
        </div>
        <div class="credits">
          Designed by <a href="https://abhinaysharma.com/">abhinaysharma</a>
        </div>
      </div>
    </footer>
        
      </div>
    )
  }

  export default Footer;

